import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription, catchError, map, of, share, tap } from 'rxjs';
import { ServiceBase } from './service-base';
import { SelectListItem } from '../models';
import { ActivationStart, Router } from '@angular/router';
import { SnackbarFactory } from './snackbar-factory';

@Injectable()
export class CompanyRouteService extends ServiceBase<object> {

  constructor(
    private httpClient: HttpClient,
    @Inject("BASE_URL") baseUrl: string,
    private router: Router,
    private snackBar: SnackbarFactory,
  ) {
    super(httpClient, baseUrl, 'api/company-route');

    this.routerEventsSubscription = this.router.events.subscribe((event) => {
      if (event instanceof ActivationStart) {
        let id = event.snapshot.params['id'];
        this.routeId = id ? parseInt(id) : null;
      }
    });
  }

  private routerEventsSubscription: Subscription; 

  private companyList$?: Observable<SelectListItem[]>;
  private companyList: SelectListItem[] = [];

  private routeId: number = null;

  public get companyId(): number | null {
    return this.routeId ?? null;
  }

  public getAllCompanyIds(): Observable<SelectListItem[]> {
    const list = this.companyList;

    if (!list || list.length == 0) return this.getCompanyIdsSelectList();
    if (this.companyList$) return this.companyList$;

    return of(list);
  }

  public isCompanyIdValid(companyId: number): Observable<boolean> {
    return this.validateCompanyId(companyId).pipe(
      map(resp => {
        this.routeId = companyId;
        return true;
      }),
      catchError(_err => {
        this.snackBar.showButtonSnackbar(_err);
        return of(false)
      }),
    );
  }

  public getCompanyIdsSelectList(): Observable<SelectListItem[]> {
    if (this.companyList$) return this.companyList$;

    this.companyList$ = this.getRefSelectList("selectlist/companyList", { listName: "Company" })
      .pipe(
        tap(({ selectItems, defaultItem }) => {
          this.companyList = selectItems;
          this.companyList$ = null;
          if (!this.routeId && defaultItem && typeof(defaultItem.id) == "number") {
            this.routeId = defaultItem.id;
          }
        }),
        map(_ => this.companyList),
        catchError(_err => {
          this.snackBar.showButtonSnackbar(_err);
          throw Error()
        }),
        share(),
    );

    return this.companyList$;
  }

  public validateCompanyId(companyId: number) {
    return this.post(`${companyId}`, null);
  }

  ngOnDestroy(): void {
    this.routerEventsSubscription.unsubscribe();
  }
}
